import * as actions from '../actions/Message';

const initialState = {
  messages: [
    {
      messageId: 1,
      messageType: '自己紹介メッセージ',
      message: '私の名前は○○です。\n趣味は△△です。\nよろしくお願いします。',
      status: '表示',
      createdAt: '2019-07-16 12:00:00'
    },
    {
      messageId: 2,
      messageType: '感謝のメッセージ',
      message: 'とても美味しかったです。\nありがとうございます！',
      status: '表示',
      createdAt: '2019-07-16 12:00:00'
    },
    {
      messageId: 3,
      messageType: '店舗へのメッセージ',
      message:
        'いつも美味しいオムライス食べてます！ぜひ加盟店登録してください！',
      status: '通報あり',
      createdAt: '2019-07-16 12:00:00'
    },
    {
      messageId: 4,
      messageType: 'シチュエーションメッセージ',
      message: '女子限定！',
      status: '非表示',
      createdAt: '2019-07-16 12:00:00'
    },
    {
      messageId: 5,
      messageType: 'ごちメッセージ',
      message:
        'てすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすとてすと',
      status: '表示',
      createdAt: '2019-07-16 12:00:00'
    },
    {
      messageId: 6,
      messageType: 'ごちメッセージ',
      message: 'ヘルシーで美味しいので、ぜひ！',
      status: '表示',
      createdAt: '2019-07-16 12:00:00'
    }
  ],
  offset: 0,
  limit: 10,
  totalCount: 6,
  messageTypes: [
    {
      id: 'ALL',
      name: '全部'
    },
    {
      id: 'USER',
      name: '自己紹介メッセージ'
    },
    {
      id: 'GOCHI_BILL',
      name: 'ごちメッセージ'
    },
    {
      id: 'SITUATION',
      name: 'シチュエーションメッセージ'
    },
    {
      id: 'COUPON',
      name: '感謝のメッセージ'
    },
    {
      id: 'PRE_SHOP',
      name: '店舗へのメッセージ'
    }
  ],
  statuses: [
    {
      id: 'NONE',
      name: '選択してください'
    },
    {
      id: 'APPROPRIATE',
      name: '表示'
    },
    {
      id: 'REPORTED',
      name: '通報あり'
    },
    {
      id: 'BAN',
      name: '非表示'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const messages = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_MESSAGES_SUCCESS:
      return Object.assign({}, state, { messages: action.payload });
    case actions.GET_MESSAGES_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default messages;
